<template lang="html">
  <div class="insidenavigation">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" class="text-center">
        <v-chip
          v-if="helpNeeded"
          color="pink"
          @click="$router.push({name:'helpus', query:{selectedComp:'Surgos'}})"
        >
          Sürgős segítségre van szükségünk!
        </v-chip>

        <v-chip
          color="secondary"
          @click="$router.push({name:'orokbefogadas', query:{selectedComp:'ToBeAdopted'}})"
        >
          Örökbefogadásra váró védenceink
        </v-chip>

      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data(){
    return{
      helpNeeded: this.$store.getters.allAnimals.filter(a=>a.colorcode==="pink").length>0 ? true : false,
    }
  },
}
</script>

<style lang="scss" scoped>
.insidenavigation{
  margin-bottom: 30px;
}
.v-chip{
  margin: 5px 10px;
  &:hover{
    cursor: pointer;
  }
}

</style>
